import type { Action } from '../common/actions'

import {
    AlbumCreatedFromUploadFilesFlag,
    AlbumCreationEnded,
    AlbumWasCreated,
    ClearAlbumCreatedFromUploadFiles,
} from './actions'

export type AlbumCreationState = {
    createdFromUpload?: boolean
    albumJustCreated?: string
}

const initialState: AlbumCreationState = {
    createdFromUpload: undefined,
    albumJustCreated: undefined,
}

export const albumCreationReducer = (
    state: AlbumCreationState = initialState,
    action: Action,
): AlbumCreationState => {
    if (AlbumCreatedFromUploadFilesFlag.match(action)) {
        return {
            ...state,
            createdFromUpload: true,
        }
    }
    if (ClearAlbumCreatedFromUploadFiles.match(action)) {
        return {
            ...state,
            createdFromUpload: undefined,
        }
    }
    if (AlbumWasCreated.match(action)) {
        return {
            ...state,
            albumJustCreated: action.payload.jobID,
        }
    }
    if (AlbumCreationEnded.match(action)) {
        return {
            ...state,
            albumJustCreated: undefined,
        }
    }
    return state
}

export const albumCreationReducerMapObj = {
    albumCreation: albumCreationReducer,
}
export type StateWithAlbumCreation = StateOfReducerMapObj<typeof albumCreationReducerMapObj>
